import styled from 'styled-components';
import videoBgSrc from '../../assets/video-bg.png';

export const VideoWrapper = styled.div`
  margin-top: 90px;
  padding: 80px 0;
  background-image: url(${videoBgSrc});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;